import { Dispatch } from "redux";
import { camelize } from "../../config/functions";
import {
  getTaskAttachments,
  createTaskAttachment,
  updateTaskAttachment,
  deleteTaskAttachment,
  getTaskAttachmentById,
} from "../../services/TaskAttachService";
import { TaskAttachment } from "../../types/TaskAttachment";
// Action types
export enum TaskAttachmentActionList {
  ADD_TASK_ATTACHMENT = "ADD_TASK_ATTACHMENT",
  EDIT_TASK_ATTACHMENT = "EDIT_TASK_ATTACHMENT",
  FETCH_TASK_ATTACHMENTS = "FETCH_TASK_ATTACHMENTS",
  FETCH_TASK_ATTACHMENT_BY_ID = "FETCH_TASK_ATTACHMENT_BY_ID",
  DELETE_TASK_ATTACHMENT = "DELETE_TASK_ATTACHMENT",
}
// Actions
export interface AddAttachmentAction {
  type: TaskAttachmentActionList.ADD_TASK_ATTACHMENT;
  data: TaskAttachment;
}
export interface EditAttachmentAction {
  type: TaskAttachmentActionList.EDIT_TASK_ATTACHMENT;
  data: TaskAttachment;
  id: number;
}
export interface FetchAttachmentAction {
  type: TaskAttachmentActionList.FETCH_TASK_ATTACHMENTS;
  data: TaskAttachment[];
}
export interface DeleteAttachmentAction {
  type: TaskAttachmentActionList.DELETE_TASK_ATTACHMENT;
  data: number;
}
export interface FetchAttachmentByIdAction {
  type: TaskAttachmentActionList.FETCH_TASK_ATTACHMENT_BY_ID;
  data: TaskAttachment | null;
}
export type TaskAttachmentActions =
  | AddAttachmentAction
  | EditAttachmentAction
  | FetchAttachmentAction
  | FetchAttachmentByIdAction
  | DeleteAttachmentAction;
// Action Creators
export const addTaskAttachmentAction = (formData: FormData) => {
  return async (dispatch: Dispatch) => {
    return createTaskAttachment(formData)
      .then((response) => {
        if (response.status === 200 && response.data.data) {
          const rawData = response.data.data;
          let attachment: any = {};
          for (let key in rawData) {
            attachment[camelize(key)] = rawData[key];
          }
          dispatch<AddAttachmentAction>({
            type: TaskAttachmentActionList.ADD_TASK_ATTACHMENT,
            data: attachment,
          });
          return Promise.resolve(response.data.message ?? "Attachment added");
        } else {
          throw { response };
        }
      })
      .catch((error) =>
        Promise.reject(
          error.response?.data?.message ?? "Unable to add attachment",
        ),
      );
  };
};
export const editTaskAttachmentAction = (id: number, data: TaskAttachment) => {
  return async (dispatch: Dispatch) => {
    return updateTaskAttachment(id, data)
      .then((response) => {
        if (response.status === 200 && response.data.data) {
          const rawData = response.data.data;
          let attachment: any = {};
          for (let key in rawData) {
            attachment[camelize(key)] = rawData[key];
          }
          dispatch<EditAttachmentAction>({
            type: TaskAttachmentActionList.EDIT_TASK_ATTACHMENT,
            data: attachment,
            id,
          });
          return Promise.resolve(response.data.message ?? "Attachment updated");
        } else {
          throw { response };
        }
      })
      .catch((error) =>
        Promise.reject(
          error.response?.data?.message ?? "Unable to update attachment",
        ),
      );
  };
};
export const fetchTaskAttachmentsAction = () => {
  return async (dispatch: Dispatch) => {
    const response = await getTaskAttachments();
    console.log(response);
    dispatch<FetchAttachmentAction>({
      type: TaskAttachmentActionList.FETCH_TASK_ATTACHMENTS,
      data: response,
    });
  };
};
export const fetchTaskAttachmentByIdAction = (id: string) => {
  return async (dispatch: Dispatch) => {
    try {
      const rawData = await getTaskAttachmentById(id);
      dispatch<FetchAttachmentByIdAction>({
        type: TaskAttachmentActionList.FETCH_TASK_ATTACHMENT_BY_ID,
        data: rawData.data,
      });
    } catch (error: any) {
      console.error("Failed to fetch attachment by ID", error);
      dispatch<FetchAttachmentByIdAction>({
        type: TaskAttachmentActionList.FETCH_TASK_ATTACHMENT_BY_ID,
        data: null,
      });
    }
  };
};
export const deleteTaskAttachmentAction = (id: number) => {
  return async (dispatch: Dispatch) => {
    return deleteTaskAttachment(id)
      .then((response) => {
        if (response.status === 200) {
          dispatch<DeleteAttachmentAction>({
            type: TaskAttachmentActionList.DELETE_TASK_ATTACHMENT,
            data: id,
          });
          return Promise.resolve(response.data.message ?? "Attachment deleted");
        } else {
          throw { response };
        }
      })
      .catch((error) =>
        Promise.reject(
          error.response?.data?.message ?? "Unable to delete attachment",
        ),
      );
  };
};
